import {Component, Inject, LOCALE_ID, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {Loaning} from '../../common/services/loaning/loaning.model';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {LoaningService} from '../../common/services/loaning/loaning.service';
import {LoaningState} from '../../common/services/loaning/loaning-states.enum';
import {formatDate} from '@angular/common';
import {Deposit} from '../../common/services/deposit/deposit.model';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {environment} from '@Env/environment';
import * as FileSaver from "file-saver";
import {finalize} from "rxjs/operators";
import {PubSubService} from "@Common/core/services";
import {saveAs} from "file-saver";

@Component({
  selector: 'app-my-loanings',
  templateUrl: './my-loanings.component.html',
  styleUrls: ['./my-loanings.component.scss']
})
export class MyLoaningsComponent implements OnInit, OnDestroy {
  urlList = `${environment.baseUrl}/api_archive/loaning/my_loanings/`;
  columns: ColumnDataTable[] = [{
    columnDef: 'status', header: 'Etat de la demande',
    display: (loaning: Loaning) => this.loaningSvc.getChipButton(loaning),
    sort: true, flex: 15
  },
    {
      columnDef: 'dt_created', header: 'Date création',
      display: (loaning: Loaning) => this.loaningSvc.getDateFr(loaning.dt_created),
      sort: true, flex: 10
    },
    {
      columnDef: 'date_send', header: 'Date de la demande',
      display: (loaning: Loaning) => this.loaningSvc.getDateFr(loaning.date_send, 'non envoyée'),
      sort: true, flex: 10
    },
    {
      columnDef: 'reference', header: 'Référence',
      display: (loaning: Loaning) => loaning.reference || '-',
      sort: true
    },
  ];
  actions: ActionDataTable[] = [{
    label: 'Supprimer', tooltip: 'Supprimer cette demande', icon: 'delete',
    click: (loaning: Loaning) => this._delete(loaning),
    hidden: (loaning: Loaning) => this._deleteIsHidden(loaning),
    iconcolor: 'warn',
  },
    {
      label: 'Modifier', tooltip: 'Continuer votre demande', icon: 'edit',
      click: (loaning: Loaning) => this._edit(loaning),
      hidden: (loaning: Loaning) => this._editIsHidden(loaning),
      iconcolor: 'accent',
    },
    {
      label: 'Visualiser', tooltip: 'Visualiser cette demande', icon: 'visibility',
      click: (loaning: Loaning) => this._preview(loaning),
      iconcolor: 'accent',
    },
    {
      label: 'Pdf de la demande', tooltip: 'Imprimer cette demande', icon: 'picture_as_pdf',
      click: (loaning: Loaning) => this.exportPdfConsultation(loaning),
      iconcolor: 'accent',
    },
    {
      label: 'Télécharger scans', tooltip: 'Télécharger les scans', icon: 'cloud_download',
      click: (loaning: Loaning) => this.exportZipScansConsultation(loaning),
      hidden: (loaning: Loaning) => !this.showExportZipBtn(loaning),
      iconcolor: 'accent',
    },
  ];
  dsLoaning: MatDataSourceGeneric<Loaning> = new MatDataSourceGeneric<Loaning>();
  extraParams: Map<string, string> = new Map<string, string>();
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  subSink = new SubSink();
  constructor(@Inject(LOCALE_ID) private locale: string,
              private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private pubSubSvc: PubSubService,
              private loaningSvc: LoaningService) {
    this.dsLoaning.daoService = loaningSvc;
  }

  ngOnInit(): void {
  }

  exportZipScansConsultation(loaning) {
    const { scans_obj } = loaning;
    if (scans_obj.length > 1) {
      this.exportMultipleScansConsultation(loaning);
    } else if (scans_obj.length === 1) {
      this.downloadSingleScan(loaning);
    }
  }

  exportMultipleScansConsultation(loaning: Loaning) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc
      .exportZipScansConsultation(loaning)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((data: Blob) => {
        const zipName = `${loaning.reference}`;
        const fileName = `${zipName}.zip`;
        saveAs(data, fileName);
      });
  }

  downloadSingleScan(loaning: Loaning) {
    // Cas ou il'y as un seul scan
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc
      .downloadSingleScan(loaning.scans_obj[0])
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false)),
      )
      .subscribe();
  }

  exportPdfConsultation(loaning) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc.exportConsultationPdf(loaning).pipe(
      finalize(() => this.pubSubSvc.publish('loading', false))
    ).subscribe(
      (_data) => FileSaver.saveAs(_data, `${loaning.reference}.pdf`)
    )
  }

  addConsultation() {
    this.router.navigate(['nouvelle-consultation'], {relativeTo: this.route.parent});
  }
  private _edit(loaning: Loaning) {
    this.router.navigate(['edition-consultation', loaning.uuid], {relativeTo: this.route.parent});
  }
  private showExportZipBtn(loaning: Loaning) {
    return (loaning.status === LoaningState.DONE && loaning.scans_obj.length > 0);
  }
  private _editIsHidden(loaning: Loaning) {
    const editEnable: LoaningState[] = [LoaningState.DRAFT];
    return !editEnable.includes(loaning.status);
  }
  private _preview(loaning: Loaning) {
    this.router.navigate([loaning.uuid], {relativeTo: this.route.parent});
  }
  private _delete(deposit: Deposit) {
    const data = new DialogData();
    data.title = `Suppression de la demande de consultation`;
    data.message = '';
    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.subSink.sink = this.loaningSvc.delete(deposit).subscribe(_ => this.dataTable.reload());
        }
      }
    );
  }
  private _deleteIsHidden(loaning: Loaning) {
    return loaning.status !== LoaningState.DRAFT;
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
